// extracted by mini-css-extract-plugin
module.exports = {"controls":"MapControls_controls__vFm-D","recenter":"MapControls_recenter__1PFG2","zoom":"MapControls_zoom__5jO9j","inner":"MapControls_inner__2l8p_"};